import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import './style.css';
import './style2.css';
import 'primeicons/primeicons.css';
import Tooltip from 'primevue/tooltip';


import ToastService from 'primevue/toastservice';

const app = createApp(App);
app.use(router);
app.use(ToastService);
app.directive('tooltip', Tooltip);
app.use(PrimeVue,{
    theme:{
        preset:Aura
    }
});

app.mount('#app');
